import React from 'react';
import Card from '@mui/material/Card';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import '../css/about.css';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import IconButton from '@mui/material/IconButton';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  cardRadius:{
    borderRadius: 4,
  },

  gridContent:{
    display: 'flex',
    justifyContent: 'center',

  },
  mainFont:{
    fontFamily: 'Arial'
  },
  card: {
    padding: 1,
  },
}));

const About = () => {

  const classes = useStyles();

    const cardInfo = [
        {image: "img/owner.jpg", name: "Barbara Gordon", position:"Owner"},
        {image: "img/head-chef.jpg", name: "Tim Drake", position:"Head Chef"},
        {image: "img/sous-chef.jpg", name: "Selina Kyle", position:"Sous Chef"},
    ];

    const renderCard = (card, index) => {
        return(
            <Card
                className="card small"
                spacing={1}
                style={{
                    borderRadius: "4px",
                    width: '100%', // Ensure the card takes up the full width of the grid column
                    maxWidth: '200px', // Limit the card width
                    margin: '0 auto',
                }}
                key={index}
            >
                <CardMedia
                    component="img"
                    alt={card.position}
                    height="200"
                    image={card.image}
                    title={card.owner}
                    className="card-image"
                />
                <CardContent>
                    <Typography gutterBottom variant="h4" component="h2" align="center" style={{fontFamily: 'Poiret One', fontWeight: 'bold'}}>
                        {card.name}
                    </Typography>
                    <Typography gutterBottom variant="h6" component="h2" align="center">
                        {card.position}
                    </Typography>
                </CardContent>
                <CardActions style={{ justifyContent: 'center' }}>
                    <IconButton style={{ padding: '8px' }} aria-label="LinkedIn">
                        <LinkedInIcon />
                    </IconButton>
                </CardActions>
            </Card>

        )
    };

    return (
        <div className='container'>
            <Container maxWidth="lg" style={{marginTop: '16px'}}>
                <Typography gutterBottom variant="h3" component="h2" align="left" className={classes.mainFont} >
                    About
                </Typography>
                <Typography variant="body1" gutterBottom style={{lineHeight: 2}}>
                King Triton’s Seafood Palace was founded in 1999.
                King Triton’s gets its name from the 1989 Disney movie, The Little Mermaid, a movie the owner’s son loved as a child.
                Barbara Gordon originally opened her first espresso, doughnut and sandwich shop in 1996 and when that proved to be a fruitful business venture, she expanded and rebranded to what is now known as King Triton’s Seafood Palace.
                It has turned into what is considred by some to the best Seafood Restaurant in Barbados. At King Triton's Seafood Palace Barbados, you can appreciate a wide variety of seafood delights, espresso, drinks, and sandwiches; food fit for a king.
                </Typography>
            </Container>

            <Box
                sx={{
                    width: '100%',
                    maxWidth: '900px',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: 1,
                    justifyContent: 'center',
                    margin: '0 auto',
                    textAlign: 'center',
                    alignItems: 'center',
                    padding: 0,
                }}
                >
                {cardInfo.map(renderCard)}
            </Box>
        </div>
    );
}

export default About;
